import { Map, List, fromJS } from 'immutable'

export function articlesData(state = Map({}), action) {
	switch(action.type) {
		case 'ARTICLES_DATA_FETCH_SUCCESS':
			return Map(action.articlesData)
		case 'ARTICLES_DATA_FETCH_ERROR':
			return state
		default:
			return state
	}
}

export function articlesDataError(state = false, action) {
	switch(action.type) {
		case 'ARTICLES_DATA_FETCH_ERROR':
			return action.error
		case 'ARTICLES_DATA_FETCH_SUCCESS':
			return false
		default:
			return state
	}
}

export function wpPosts(state = List([]), action) {
	switch(action.type) {
		case 'WP_POSTS_FETCH_SUCCESS':
		case 'WP_POSTS_SEARCH_SUCCESS':
		case 'WP_POSTS_CATEGORY_FETCH_SUCCESS':
			return fromJS(action.wpPosts)
		case 'WP_POSTS_FETCH_ERROR':
		case 'WP_POSTS_SEARCH_ERROR':
		case 'WP_POSTS_CATEGORY_FETCH_ERROR':
			return state
		default:
			return state
	}
}

export function wpPostsPagination(state = Map({}), action) {
	switch(action.type) {
		case 'WP_POSTS_FETCH_SUCCESS':
		case 'WP_POSTS_SEARCH_SUCCESS':
		case 'WP_POSTS_CATEGORY_FETCH_SUCCESS':
			return Map(action.pagination)
		case 'WP_POSTS_FETCH_ERROR':
		case 'WP_POSTS_SEARCH_ERROR':
		case 'WP_POSTS_CATEGORY_FETCH_ERROR':
			return state
		default:
			return state
	}
}

export function wpPostsError(state = false, action) {
	switch(action.type) {
		case 'WP_POSTS_FETCH_ERROR':
		case 'WP_POSTS_SEARCH_ERROR':
		case 'WP_POSTS_CATEGORY_FETCH_ERROR':
			return action.error
		case 'WP_POSTS_FETCH_SUCCESS':
		case 'WP_POSTS_SEARCH_SUCCESS':
		case 'WP_POSTS_CATEGORY_FETCH_SUCCESS':
			return false
		default:
			return state
	}
}

export function wpPostsSearchQuery(state = '', action) {
	switch(action.type) {
		case 'WP_POSTS_SEARCH_SUCCESS':
			return action.searchQuery || ''
		case 'WP_POSTS_FETCH_SUCCESS':
		case 'WP_POSTS_CATEGORY_FETCH_SUCCESS':
			return ''
		default:
			return state
	}
}

export function wpPostsSelectedCategory(state = 'all', action) {
	switch(action.type) {
		case 'WP_POSTS_CATEGORY_FETCH_SUCCESS':
			return action.selectedCategory || 'all'
		case 'WP_POSTS_FETCH_SUCCESS':
		case 'WP_POSTS_SEARCH_SUCCESS':
			return 'all'
		default:
			return state
	}
}

export function latestWpPosts(state = List([]), action) {
	switch(action.type) {
		case 'LATEST_WP_POSTS_FETCH_SUCCESS':
			return fromJS(action.latestWpPosts)
		case 'LATEST_WP_POSTS_FETCH_ERROR':
			return state
		default:
			return state
	}
}

export function latestWpPostsError(state = false, action) {
	switch(action.type) {
		case 'LATEST_WP_POSTS_FETCH_ERROR':
			return action.error
		case 'LATEST_WP_POSTS_FETCH_SUCCESS':
			return false
		default:
			return state
	}
}

export function wpPostDetail(state = Map({}), action) {
	switch(action.type) {
		case 'WP_POST_BY_ID_FETCH_SUCCESS':
			return fromJS(action.wpPostDetail)
		case 'WP_POST_BY_ID_FETCH_ERROR':
			return Map({})
		default:
			return state
	}
}

export function wpPostDetailError(state = false, action) {
	switch(action.type) {
		case 'WP_POST_BY_ID_FETCH_ERROR':
			return action.error
		case 'WP_POST_BY_ID_FETCH_SUCCESS':
			return false
		default:
			return state
	}
}
